import { memo } from "react";

/* Floating decorative pearls used in the hero canvas. */
const PEARLS = [
  { size: 42, x: 8,  y: 12, d: 0,    hue: "pink" },
  { size: 18, x: 18, y: 78, d: 1.2,  hue: "violet" },
  { size: 28, x: 86, y: 18, d: 2.4,  hue: "pink" },
  { size: 14, x: 92, y: 62, d: 0.8,  hue: "violet" },
  { size: 22, x: 72, y: 84, d: 3.1,  hue: "pink" },
  { size: 12, x: 26, y: 26, d: 1.8,  hue: "violet" },
  { size: 36, x: 60, y: 8,  d: 0.4,  hue: "pink" },
  { size: 10, x: 44, y: 92, d: 2.1,  hue: "violet" },
];

function HeroPearls() {
  return (
    <>
      {PEARLS.map((p, i) => (
        <span
          key={i}
          aria-hidden="true"
          className="absolute bp-float"
          style={{
            width: p.size,
            height: p.size,
            left: `${p.x}%`,
            top: `${p.y}%`,
            borderRadius: "9999px",
            animationDelay: `${p.d}s`,
            background:
              p.hue === "pink"
                ? "radial-gradient(circle at 30% 28%, #ffffff 0%, #ffd2e6 45%, #ec4899 95%)"
                : "radial-gradient(circle at 30% 28%, #ffffff 0%, #ddd0f7 45%, #5B3FD1 95%)",
            boxShadow:
              "inset -4px -6px 12px rgba(60,40,120,0.35), 0 10px 18px -10px rgba(91,63,209,0.45)",
          }}
        />
      ))}
    </>
  );
}

export default memo(HeroPearls);
